import React from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import TimerIcon from '@material-ui/icons/Timer';
import {convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import {getColorForPercentage} from "../../../utils/utils";

const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        backgroundColor: 'white',
    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
       // alignSelf: 'stretch',
    },

    nomeEtapa: {
        //backgroundColor: 'red',
        display: 'flex',
        justifyContent: 'center',
        alignSelf: 'center',
       // borderBottom: '1px solid red'
    },
    valoresArea: {
      //  backgroundColor: 'green'
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',

    },
    fila: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    concluidos: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    tempomedio: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignSelf: 'center',
        fontSize:'2rem'
    },
    tempoLabel: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'flex-end',
        paddingTop: '2px'
    },
    tempoValor: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly'

    }

}));


    const EtapaFoto = ({ foto, tempo, index }) => {

    const classes= useStyles();

        let tmed = 0;
        if (foto.tempoTotalEspera && foto.quantidadeOS && foto.tempoTotalEspera > 0 && foto.quantidadeOS > 0 ) {
            tmed =  new Date(Math.round(foto.tempoTotalEspera / foto.quantidadeOS)) ;
        }

        let styleGradiente = ""
        let perc = 0;
        if (foto.processoEtapa && tempo) {
            if (tempo.avgTempoSec < foto.processoEtapa.tempoReferenciaMinimoSec) {
                styleGradiente = '#82E4F7FF';
                styleGradiente = 'yellow';
            }
            if (tempo.avgTempoSec >= foto.processoEtapa.tempoReferenciaMinimoSec  &&
                tempo.avgTempoSec <= foto.processoEtapa.tempoReferenciaMaximoSec  ) {
                 perc =  ( 1- ( (tempo.avgTempoSec - foto.processoEtapa.tempoReferenciaMinimoSec) /
                                 (foto.processoEtapa.tempoReferenciaMaximoSec - foto.processoEtapa.tempoReferenciaMinimoSec)  ));
                styleGradiente = getColorForPercentage(perc);
                styleGradiente = 'green';

            }
            if (tempo.avgTempoSec > foto.processoEtapa.tempoReferenciaMaximoSec  ) {
                styleGradiente = 'red';
            }

        }

        let tempoMin = "--";
        let tempoMax = "--";
        if (foto && foto.processoEtapa) {
            tempoMin = Math.round(foto.processoEtapa.tempoReferenciaMinimoSec/60);
            tempoMax = Math.round(foto.processoEtapa.tempoReferenciaMaximoSec/60);
        }

        return (
            <Grid item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item className={classes.mainGrid} style={{ backgroundColor: styleGradiente }} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid item className={classes.nomeEtapa} xs={6} sm={4} md={6} lg={6} xl={6}>
                            <Typography variant="h3">{foto.descricao.toUpperCase()}</Typography>

                    </Grid>

                        <Grid item className={classes.fila} xs={4} sm={2} md={2} lg={1} xl={1}>
                            <Typography variant="h3">{foto.quantidadeOS}</Typography>
                            <Typography variant="overline">FILA</Typography>
                        </Grid>
                        <Grid item container className={classes.concluidos} xs={2} sm={2} md={2} lg={2} xl={2}>
                            <Typography variant="h2" style={{fontWeight:"fontWeightBold"}}>{foto.concluidos}</Typography>
                            <Typography variant="overline">CONCLUÍDOS</Typography>
                        </Grid>

                        <Grid item container className={classes.concluidos} xs={2} sm={2} md={2} lg={2} xl={2}>

                                    <Typography variant="h2"> {tempo ? convertSecondsToMinutesSecondsFormat(tempo.avgTempoSec) : '--'} </Typography>
                            <Typography variant="h6">{tempoMin} {'<'} <TimerIcon style={{fontSize:'1rem', height:'1em'}}/> {'<'} {tempoMax}</Typography>
                            {/*{foto.processoEtapa && tempo &&*/}
                            {/*<Typography*/}
                            {/*    variant="overline">{perc} {tempo.avgTempoSec} {foto.processoEtapa.tempoReferenciaMinimoSec} {foto.processoEtapa.tempoReferenciaMaximoSec}</Typography>*/}
                            {/*}*/}


                        </Grid>


                </Grid>
            </Grid>



        )
    }

export default EtapaFoto;
